// extracted by mini-css-extract-plugin
export default {"tag":"UserLabel__tag___366uh","new":"UserLabel__new___3i1x0","early":"UserLabel__early___2jXIo","vip":"UserLabel__vip___N5ZR5"};